// extracted by mini-css-extract-plugin
module.exports = {"modal":"NewAuth_modal__0SWQx","modalContent":"NewAuth_modalContent__fuSXy","body":"NewAuth_body__laRIC"};